import data from "../../../../../src/NavList/NavList.docs.json";
import * as React from 'react';
export default {
  data,
  React
};